import { useQuery } from "@tanstack/react-query";
import apiClient from "@/lib/api-client";

export interface CrossConceptPaper {
  paper_id: string;
  title: string;
  similarity: number;
}

export interface CrossConceptSuggestion {
  concept_id: string;
  concept_name: string;
  papers: CrossConceptPaper[];
}

export interface CrossConceptResponse {
  suggestions: CrossConceptSuggestion[];
}

export function useCrossConceptSuggestions(
  conceptId: string,
  paperId: string | undefined,
) {
  return useQuery({
    queryKey: ["cross-concept", conceptId, paperId],
    queryFn: () =>
      apiClient
        .get(`api/concepts/${conceptId}/papers/${paperId}/cross-concept`)
        .json<CrossConceptResponse>(),
    enabled: !!conceptId && !!paperId,
    staleTime: 5 * 60_000,
  });
}
